export const validatePhoneNumber = (phone) => {
  const regex = /^\d{2} \d{4,5}-\d{4}$/;
  return regex.test(phone);
};

export const formatPhoneNumber = (phone) => {

  phone = phone.replace(/\D/g, '')

  if (phone.length === 11) {
    phone = phone.replace(/^(\d{2})(\d{5})(\d{4})/, '$1 $2-$3')
  }

  if (phone.length === 10) {
    phone = phone.replace(/^(\d{2})(\d{4})(\d{4})/, '$1 $2-$3')
  }

  if (phone.length === 9) {
    phone = phone.replace(/^(\d{5})(\d{4})/, '$1-$2')
  }

  if (phone.length === 8) {
    phone = phone.replace(/^(\d{4})(\d{4})/, '$1-$2')
  }

  return phone
};